import { UserRound, Users } from "lucide-react";
import { Chapter, MaskLine, Reveal } from "@/components/motion";
import { fileUrl } from "@/lib/api";
import { txt } from "@/lib/site";

export function OurPastor({ site }) {
  const list = site?.pastors || [];
  if (!list.length) return null;
  return (
    <section id="pastor" data-testid="our-pastor-section" className="bg-white border-y border-slate-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-36">
        <Reveal><Chapter n="✦" label={txt(site, "pastor_section_label", "Our Pastor")} /></Reveal>
        <h2 className="mt-10 text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-slate-900 leading-[0.95]">
          <MaskLine inView>{txt(site, "pastor_section_heading", "Gembala kami.")}</MaskLine>
        </h2>
        <div className="mt-14 space-y-8">
          {list.map((p, i) => (
            <Reveal key={i} delay={i * 0.08}
              className="flex flex-col md:flex-row bg-slate-50 rounded-[2rem] overflow-hidden border border-slate-100 md:min-h-[22rem]"
              data-testid={`pastor-item-${i}`}>
              <div className="md:w-2/5 aspect-[4/3] md:aspect-auto bg-slate-900 shrink-0">
                {p.photo
                  ? <img src={fileUrl(p.photo)} alt={p.name} className="w-full h-full object-cover" />
                  : <div className="w-full h-full grid place-items-center text-white/20"><UserRound className="w-16 h-16" /></div>}
              </div>
              <div className="flex-1 p-7 md:p-12 flex flex-col justify-center">
                <p className="text-[11px] font-bold uppercase tracking-widest text-blue-600">{p.title}</p>
                <p className="mt-2 text-3xl md:text-4xl font-black tracking-tight text-slate-900" data-testid={`pastor-name-${i}`}>{p.name}</p>
                <p className="mt-5 text-slate-500 leading-relaxed whitespace-pre-line max-w-2xl">{p.description}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export function OurTeam({ site }) {
  const list = site?.team || [];
  if (!list.length) return null;
  return (
    <section id="team" data-testid="our-team-section" className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-36">
      <Reveal><Chapter n="✦" label={txt(site, "team_section_label", "Our Team")} /></Reveal>
      <h2 className="mt-10 text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-slate-900 leading-[0.95]">
        <MaskLine inView>{txt(site, "team_section_heading", "Tim pelayanan.")}</MaskLine>
      </h2>
      <div className="mt-14 grid gap-6 md:grid-cols-2">
        {list.map((m, i) => (
          <Reveal key={i} delay={i * 0.06}
            className="flex bg-white rounded-[1.75rem] overflow-hidden border border-slate-100 shadow-sm min-h-[10rem]"
            data-testid={`team-item-${i}`}>
            <div className="w-32 sm:w-44 shrink-0 bg-slate-100">
              {m.photo
                ? <img src={fileUrl(m.photo)} alt={m.name} className="w-full h-full object-cover" />
                : <div className="w-full h-full grid place-items-center text-slate-300"><Users className="w-10 h-10" /></div>}
            </div>
            <div className="flex-1 p-5 sm:p-7 flex flex-col justify-center">
              <p className="text-[11px] font-bold uppercase tracking-widest text-indigo-600">{m.role}</p>
              <p className="mt-1 text-xl font-black text-slate-900 leading-tight" data-testid={`team-name-${i}`}>{m.name}</p>
              <p className="mt-2 text-sm text-slate-500 leading-relaxed whitespace-pre-line">{m.description}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
